<template>
  <div class="msp-allenamento-item">
    <v-card
    outlined
    @click="clickItem"
    >

    <v-list-item three-line
    >

    <v-list-item-avatar
    tile
    >
    <i class="ev-all__icon " :class="'msp-icon-sport-'+allenamento.sport_id" alt=""></i>

  </v-list-item-avatar>


  <v-list-item-content>
  <h2 v-if="!isRiposo">{{allenamento.titolo}}</h2>
  <h2 v-else>Riposo</h2>
  <div class="totalone" v-if="allenamento.totalone">
                <span v-for="field in campiSport"
                        :key="field.key"
                        :class="['ev-' + field.key]"
                    >
                        <span v-if="!isFieldHidden(field, 'allenamento')"
                              :class="'ev-all__content--' + field.key"
                              v-html="renderRisultatoBySport(values, field.key, field.um, allenamento.sport_id, !showDettaglioAttivita, !showDettaglioAttivita ? 'assegnato' : null)">
                        </span>
                        <span v-else-if="allenamento.attivita">-</span>
                    </span>
</div>


</v-list-item-content>
</v-list-item>
<div v-if="hasGraficoAndature(allenamento)" class="grafico-andature">
        <msp-grafico-andature-semplice
            v-bind = "allenamento.totalone.grafico"
            :colore = "false"
        />
</div>

<v-card-actions v-if="allenamentoHasFooter(allenamento)">

  <v-btn v-if="allenamentoHasSlotNote(allenamento)" class="slot__note" text :class="classNote" @click.prevent.stop="openChatCalendario(allenamento.calendario_id)">
      <i class="msp-icon note" :class="iconaCommenti"></i><span class='count h-p-0' v-if="countCommenti"><span class="a-small">x&nbsp;</span>{{countCommenti}}</span>
  </v-btn>
  <v-btn :disabled="!allenamento.attivita_id" :style="stylePercentuale" class="slot__percentuale" v-if="allenamentoHasSlotPercentuale(allenamento)" text @click.prevent.stop="openAttivita(allenamento.attivita_id)"><i class="v-icon msp-icon-graph"></i><span  class="h-ml-1 percentuale" v-if="allenamento.attivita"> {{allenamento.attivita.percRaggiungimento}} </span></v-btn>
  <span class="rpe slot__rpe" v-if="valutazione && allenamentoHasSlotRpe(allenamento)" >
      <span class="valutazione" ><msp-valutazione :readonly="true" :init-value="allenamento.feedback_valutazione" :mono="true" /></span>

            <span v-if="allenamento.feedback_rpe" v-text="allenamento.feedback_rpe"></span>
       </span>
  <span :class="classBests" class="bests slot__bests" v-if="countBests" >
      <span class="bests" ><i class="icon-bests msp-icon-award"/></span>

      <span class="h-p-0"><span class="a-small">x</span> {{countBests}} </span></span>

</v-card-actions>
</v-card>
</div>
</template>

<script>
// ( emoji + rpe / commenti / % ragg. / record )
import allenamentoCalcoli from "@src/js/vue/mixins/allenamentoCalcoli.js";
import allenamentoFooter from "@src/js/vue/mixins/allenamentoFooter.js";
import valutazione from "@cached/valutazione_allenamento.json"
import MspGraficoAndatureSemplice from './MspGraficoAndatureSemplice.vue';
import MspValutazione from './MspValutazione.vue';
import _funzioni from "@src/js/msp/funzioni.js";
import _percentuali from "@cached/percentuali.json";
function getColor (percentuale) {
    let elCol = _percentuali.find(el=>(el.min<percentuale && el.max >= percentuale));
    return elCol ? elCol.col : "#ccc";
}

const component = {
  components: {
    MspGraficoAndatureSemplice,
    MspValutazione,

  },
  mixins: [
    allenamentoCalcoli,
    allenamentoFooter,
  ],
  props: [
    'allenamento'
  ],
  computed: {
        showDettaglioAttivita: function () {

            return false;
        },
        values: function () {
            return {
                mt: this.allenamento?.totalone?.mt ?? null,
                sec: this.allenamento?.totalone?.sec ?? null,
                trimp: this.allenamento?.trimp ?? null,
                durataConfronto: this.allenamento?.attivita?.durata ?? null,
            }
        },
        valuesAttivita: function () {
            return {
                mt: this.allenamento?.attivita?.metri ?? null,
                sec: this.allenamento?.attivita?.durata ?? null,
                trimp: this.allenamento?.attivita?.trimp ?? null,
                durataConfronto: this.allenamento?.totalone?.sec ?? null,
            }
        },
      stylePercentuale: function () {
          if (!_funzioni.deepProp(this.allenamento,'attivita.percRaggiungimento')) {

              return "";
          }
          const color = getColor(this.allenamento.attivita.percRaggiungimento);
          return `--percentuale-color: ${color}`;
      },
      countBests: function () {
          return this.allenamento.bests && this.allenamento.bests.length;
      },

      valutazione: function () {
          let valutazione_id = (this.allenamento.feedback_valutazione) ? this.allenamento.feedback_valutazione : 0;
          let valutazioneAtleta = valutazione.find(el=>el.id==valutazione_id);
          return valutazioneAtleta;
      },
      countCommentiNuovi: function () {
          return this.allenamento.chat_count_nuovi;
      },
      countCommenti: function () {
          return this.allenamento.chat_count_totale;
      },
      iconaCommenti: function () {
          let icona;
          if (this.countCommentiNuovi) {
              icona =  "msp-icon-note";
          } else if (this.countCommenti) {
              icona = "msp-icon-note-vuoto";
          } else {
              icona = "msp-icon-note-plus";
          }

          return icona
      },
      classNote: function () {
          if (this.countCommentiNuovi) {
              return "nuovi";
          }

          return "";
      },
      isRiposo: function ()
      {
          if (!this.allenamento)
          {
              return false;
          }
          return this.allenamento.sport_id === this.MSP().ID_RIPOSO
      },


      classAlert: function ()
      {
          if (!this.allenamento)
          {
              return "";
          }
          if (+this.allenamento.alert)
          {
              return "active";
          }
          return "";
      },
      classAllenamento: function ()
      {
          if (!this.allenamento)
          {
              return "";
          }
          let a_ca = [];
          a_ca.push("allenamento-sport-"+this.allenamento.sport_id);

          if (this.selected)
          {
              a_ca.push('selected');
          }

          if (this.ghost)
          {
              a_ca.push('ghost');
          }
          if (this.over)
          {
              a_ca.push('over');
          }
          if (!this.allenamento.risultato_id)
          {
              a_ca.push('hasNotRisultato');
          }
          if (this.hasMenu)
          {
              a_ca.push('has-menu');
          }

          return a_ca.join(" ");
      }
  },
  mounted() {
  },
  methods: {
        isFieldHidden: function (field, tipo) {
            return field.hidden && field.hidden.indexOf(tipo) !== -1;
        },
    clickItem: function ()
    {
      this.$emit("click", this.allenamento);
    },
    openAttivita: function (attivita_id) {
        if (!attivita_id) return;
      this.$emit("open-attivita", attivita_id);
    },
    openChatCalendario: function (calendario_id) {
      this.$emit("open-chat-calendario", calendario_id);
    },

  }
}
export default component;
</script>

<style lang="scss">
.msp-allenamento-item {
    --footer-icon-size: 20px;
    --footer-font-size: 12px;
    .count {
        color: #000;
        padding: 2px;
    }
    .excerpt {
        white-space: nowrap;
        max-width: 250px;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .v-rating button {
        padding: 0;
    }
    .v-list-item {
        padding: 5px 16px 0px 5px;
    }
    .v-list-item__avatar {
        --avatar-size: 30px;
        &.v-avatar {
            width: var(--avatar-size);
            height: var(--avatar-size);
            min-height: var(--avatar-size);
            margin: 5px 5px 0px 0;
            i {
                font-size: var(--avatar-size);
            }
        }
    }
    h2 {
        font-size: 1em;
        margin-bottom: 15px !important;
    }
    [class^="ev-all__icon"] {
        font-size: 1em;
    }

    .totalone {
        display: flex;
        white-space: nowrap;
        overflow-x: hidden;
        align-items: center;
        gap: 8px;
        &>span {
            margin: 0 5px 0 0;
        }
    }
    .v-card__actions {
        display: grid;
        position: relative;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        grid-template-areas: "rpe note percentuale bests";
        padding: 5px 10px;
        &,
        .v-btn {
        font-size: var(--footer-font-size);
        }
    }
    .slot {
        &__note {
            grid-area: note;
            justify-content: center;
            align-items: stretch;
            text-transform: none;
            --color: var(--col-grigio);
            &.nuovi i {
                --color: var(--col-msp);
            }
            i {
                font-size: var(--footer-icon-size);
                color: var(--color);
            }
        }
        &__rpe {
            grid-area: rpe;
            justify-content: center;
        }
        &__bests {
            grid-area: bests;
            justify-content: center;
        }
        &__valutazione {
            grid-area: valutazione;
            justify-content: center;
        }
        &__percentuale {
            i {
                font-size: var(--footer-icon-size);
            color: var(--percentuale-color) !important;
        }
            grid-area: percentuale;
            justify-content: center;
            align-items: stretch;
        }
    }
    .rpe {
        display: flex;
        align-items: center;
        i {
            font-size: 1em;
        }
    }

    .bests {
        display: flex;
        align-items: center;
        i {
            font-size: var(--footer-icon-size);
        }
    }

    .valutazione .msp-valutazione-mobile {
        padding: 0;
        .valutazione-testo {
            display: none;
        }
        .valutazione-icona {
            font-size: var(--footer-icon-size);
        }
    }

    .grafico-andature {
        height: 50px;
    }
    .placeholder {
        filter: grayscale(1);
        opacity: 0.3;
    }

    .valutazione {
        grid-area: valutazione;
    }

    .rpe {
        grid-area: rpe;
    }

    .percentuale {
        grid-area: percentuale;
    }

    .note {
        grid-area: note;
    }
    .icon-bests {
        --ico-color: var(--col-grigio);
    }
    .small {
        font-size: 0.8em;
    }
    .gold .icon-bests {
        --ico-color: gold;
    }
}
</style>
